import { Autocomplete as MuiAutoComplete, TextField } from "@mui/material";
import { merge } from "lodash";

export default function AutoComplete({ props, rest }: any) {
  const { placeholder = "Asset Type" } = rest;

  const RenderComponent = (params: any) => (
    <TextField placeholder={placeholder} {...params} />
  );

  const mergedProps = merge(
    {
      // pass in all the default values
      renderInput: RenderComponent,
      sx: {
        minWidth: "200px",
        height: "45px",
        lineHeight: "45px",
        '& .MuiAutocomplete-popupIndicator': {
          color: 'white'
        }
      },
      size: "medium",
      blurOnSelect: true
    },
    props
  );

  return <MuiAutoComplete {...mergedProps} />;
}
